import { Card } from '@/components/ui/card';
import type { DbStatRowDto } from '@/types/dto';

const fmtNum = new Intl.NumberFormat();

export function DbStats({ rows }: { rows: DbStatRowDto[] }) {
  return (
    <Card>
      <h2 className="text-xl font-semibold mb-3">Database Row Counts</h2>
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b-2 border-accent">
            <th className="py-2 px-3 text-left text-[0.75rem] uppercase tracking-widest text-muted font-(family-name:--font-ui)">Table</th>
            <th className="py-2 px-3 text-right text-[0.75rem] uppercase tracking-widest text-muted font-(family-name:--font-ui)">Rows</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.table} className="border-b border-border">
              <td className="py-2 px-3 font-mono text-xs">{r.table}</td>
              <td className="py-2 px-3 text-right tabular-nums">{fmtNum.format(r.count)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
}
